import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root"
})
export class ToasterService {
  constructor(private toaster: ToastrService) {}

  showNotification(type: string, message: string): any {
    if (type === "success") {
      return this.toaster.success(message);
    }
    return this.toaster.error(message);
  }
}
